import React from "react";
import { Card } from "react-bootstrap";
import "../App.css";

export default function CustomCard({
  title,
  children,
  className = "",
  bodyClassName = "",
  ...rest
}) {
  return (
    <Card className={`custom-card ${className}`} {...rest}>
      {title && (
        <Card.Header className="custom-card-header">
          <span className="custom-card-title">{title}</span>
        </Card.Header>
      )}
      <Card.Body className={`custom-card-body ${bodyClassName}`}>
        {children}
      </Card.Body>
    </Card>
  );
}